import { render, staticRenderFns } from "./PartyDashboardLinks.vue?vue&type=template&id=2f9e909c&scoped=true&"
var script = {}
import style0 from "./PartyDashboardLinks.vue?vue&type=style&index=0&id=2f9e909c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e909c",
  null
  
)

export default component.exports